import { Component, Inject, PLATFORM_ID } from '@angular/core';
import WertWidget from '@wert-io/widget-initializer';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { v4 as uuidv4 } from 'uuid';

import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { selectedLang } from '../../app.component';
import { AnalyticsService } from '../../services/analytics.service';
import { PresaleDataService } from '../../services/connection-services/data.service';
import { EvmPurchseService } from '../../services/evm-services/evm-purchase.service';
import { SolPurchaseService } from '../../services/sol-services/sol-purchase.service';
import { CHAINS, SwapStatus, wertLangs } from '../../shared/constants/app-enums';
import { getABI } from '../../shared/constants/wallet-connect.const';
import { IWertPayload } from '../../shared/interfaces/common.interface';

@Component({
  selector: 'app-wert',
  templateUrl: './wert.component.html',
  styleUrls: ['./wert.component.scss'],
})
export class WertComponent {
  token: string = environment.tokenName;
  baseToken!: number;
  swapToken!: number;
  isStake = false;
  walletAddress!: string;
  wertWidget!: WertWidget;
  wertOptions: {
    partner_id: string;
    origin: string;
    click_id: string; // must be unique for any request
    lang: string;
    theme: string;
    currency: string;
    commodity: string;
    network: string;
    redirect_url: string;
    extra: {
      item_info: {
        name: string;
        image_url: string;
      };
    };
  } = {
      partner_id: environment.partnerId,
      origin: environment.wertOrigin,
      click_id: uuidv4(), // must be unique for any request
      lang: wertLangs[selectedLang] || 'en',
      theme: 'dark',
      currency: 'USD',
      commodity: 'USDC',
      network: environment.production ? 'ethereum' : 'sepolia',
      redirect_url: environment.domain,
      extra: {
        item_info: {
          name: environment.tokenName,
          image_url: environment.domain + '/assets/images/svg-icons/logo.svg',
        },
      },
    };
  SwapStatus = SwapStatus;
  mountError: boolean = false;
  currentStep: number = 0;
  walletType: string = '';
  swapStatus!: SwapStatus;

  constructor(
    @Inject(PLATFORM_ID) private _platformId: Object,
    public modalRef: BsModalRef,
    private http: HttpClient,
    private dataService: PresaleDataService,
    private evmPurchaseService: EvmPurchseService,
    private solPurchaseService: SolPurchaseService,
    private analyticsService: AnalyticsService,
  ) {
    this.evmPurchaseService.$transactionUpdates.subscribe((item) => {
      this.swapStatus = item.status;
    });
  }

  /**
   * Get Wert Payload according to the selected chain
   * @returns - Custom payload for both Eth and Sol chains
   */
  async getWertPayload(): Promise<IWertPayload> {
    let commodityAmount = 0;
    let inputData = '';
    if (this.dataService.activeChain === CHAINS.SOL) {
      const amount = +(this.baseToken * this.dataService.balanceDataSOl.oneSol);
      commodityAmount = +((amount * 1.02) + 0.0015).toFixed(6);
      try {
        inputData = await this.solPurchaseService.buyWithWert(this.baseToken, +((amount * 1.02)).toFixed(6));
      } catch (error) {
        console.log(error)
      }
    } else {
      commodityAmount = +this.swapToken;
      inputData = await getABI(this.baseToken, this.isStake, this.walletAddress, this.dataService.chainId, this.dataService.wagmiConfig);
    }
    return {
      address: this.walletAddress,
      commodity: this.dataService.activeChain === CHAINS.SOL ? 'SOL' : 'USDC',
      network: this.dataService.activeChain === CHAINS.SOL ? 'solana' : environment.production ? 'ethereum' : 'sepolia',
      commodity_amount: commodityAmount,
      sc_address: this.dataService.activeChain === CHAINS.SOL ? environment.sol.presaleAddress : environment.eth.presaleAddress,
      sc_input_data: inputData,
    };
  }

  /**
   * Creates Wert options object according to selected chain
   * @returns - Wert Options according to the chain selected
   */
  getWertOptions() {
    return {
      partner_id: environment.partnerId,
      origin: environment.wertOrigin,
      click_id: uuidv4(), // must be unique for any request
      lang: wertLangs[selectedLang] || 'en',
      theme: 'dark',
      currency: 'USD',
      commodity: this.dataService.activeChain === CHAINS.SOL ? 'SOL' : 'USDC',
      network: this.dataService.activeChain === CHAINS.SOL ? 'solana' : environment.production ? 'ethereum' : 'sepolia',
      redirect_url: environment.domain,
      extra: {
        item_info: {
          name: environment.tokenName,
          image_url: environment.domain + '/assets/images/svg-icons/logo.svg',
        },
      },
    }
  }

  async showWidget() {
    this.currentStep = 1;
    const payload = await this.getWertPayload();
    const wertOptions = this.getWertOptions();
    console.log('payload', payload)
    console.log('wertOptions', wertOptions)


    if (isPlatformBrowser(this._platformId)) {
      this.walletType = localStorage.getItem('connector') || '';
      this.http.post<{ data: any }>(environment.wertUrl, payload).subscribe({
        next: (res) => {
          const signedData = res.data;
          let isDashFXSent = false;

          const wertObj = { ...signedData, ...wertOptions };
          console.log('wertOptions =', wertObj);

          this.wertWidget = new WertWidget({
            ...signedData,
            ...wertOptions,
            listeners: {
              loaded: () => {
                console.log('widget loaded:');
                // this.walletConnect.swapStatus = SwapStatus.confirm_pending;
                this.evmPurchaseService.$transactionUpdates.next({ status: SwapStatus.confirm_pending });
                this.modalRef.hide();
                this.analyticsService.vwoData('wert', { openWert: true, wertPaymentStatus: 'initiated-wert', walletAddress: this.walletAddress, wertTransactionId: '' });
              },
              close: () => {
                console.log('widget closed:');
                if (this.swapStatus !== SwapStatus.wert_inprogress && this.swapStatus !== SwapStatus.complete) this.evmPurchaseService.$transactionUpdates.next({ status: SwapStatus.rejected });
              },
              position: (data: { step: string }) => console.log('step:', data.step),
              'payment-status': (status: { status: string; payment_id: string; order_id: string; tx_id: string }) => {
                console.log('payment-status:', status);

                if (status.status == 'progress' || status.status == 'pending') {
                  this.evmPurchaseService.$transactionUpdates.next({ status: SwapStatus.in_progess });
                }

                // if ((status.status == 'progress' || status.status == 'success') && !isDashFXSent) {
                //   this.walletConnect.sendDashFx('eth', this.baseToken, +((ethValue).toFixed(8)));
                //   isDashFXSent = true;
                // }

                if (status.status == 'success' && status.tx_id) {
                  // this.walletConnect.checkTransaction(status.tx_id, 'usd', this.baseToken, this.swapToken); // checking transaction status
                  this.wertWidget.removeEventListeners();
                  this.wertWidget.close();
                  this.analyticsService.vwoData('wert', { openWert: false, wertPaymentStatus: 'success', walletAddress: this.walletAddress, wertTransactionId: status.tx_id });

                  if (this.dataService.activeChain === CHAINS.EVM) {
                    this.evmPurchaseService.checkTransaction(status.tx_id, 'usd', this.baseToken, this.swapToken, "buy", "usd"); // checking transaction status
                  } else {
                    this.evmPurchaseService.$transactionUpdates.next({ status: SwapStatus.complete, hash: status.tx_id });
                    this.analyticsService.vwoData('successfulTransaction', {
                      walletAddress: this.dataService.walletAddress,
                      transactionId: status.tx_id,
                      mode: 'WERT',
                      walletName: this.dataService.connectedWalletName,
                      purchaseType: "buy",
                      tokenAmountPurchase: this.baseToken,
                      amountSpent: this.swapToken,
                      cryptoType: this.dataService.activeChain === CHAINS.SOL ? "sol" : "USDC",
                      usdAmount: +(+(this.baseToken * this.dataService.tokenomics[this.dataService.balanceDataEVM.currentStep].tokenUSDT).toFixed(2)),
                    });
                  }
                }

                if (status.status == 'canceled') {
                  this.evmPurchaseService.$transactionUpdates.next({ status: SwapStatus.rejected });
                  this.analyticsService.vwoData('wert', { openWert: false, wertPaymentStatus: 'rejected', walletAddress: this.walletAddress, wertTransactionId: status.tx_id || '' });
                  this.analyticsService.vwoData('failedAndRejectTransaction', {
                    transactionStatus: 'rejected',
                    fundSpentAmount: this.swapToken,
                    tokenAmountPurchase: this.baseToken,
                    purchaseType: this.isStake ? 'buy_and_stake' : 'buy',
                    tokenPurchaseMethod: 'card',
                    transactionId: status.tx_id,
                    walletAddress: this.walletAddress,
                    walletType: this.walletType,
                  });
                }
                // if (status.tx_id && status.status !== 'success') {
                //   this.evmPurchaseService.$transactionUpdates.next({ status: SwapStatus.wert_inprogress });
                //   // this.walletConnect.swapStatus = SwapStatus.wert_inprogress;
                //   // this.walletConnect.checkTransaction(status.tx_id, 'usd', this.baseToken, this.swapToken); // checking transaction status
                //   this.wertWidget.removeEventListeners();
                //   this.wertWidget.close();
                // }
              },
              error: (err: any) => {
                console.log('error:', err);
                // this.walletConnect.swapStatus = SwapStatus.failed;
                this.evmPurchaseService.$transactionUpdates.next({ status: SwapStatus.failed });
                this.analyticsService.vwoData('wert', { openWert: false, wertPaymentStatus: 'failed', walletAddress: this.walletAddress, wertTransactionId: '' });
                this.analyticsService.vwoData('failedAndRejectTransaction', {
                  transactionStatus: 'failed',
                  fundSpentAmount: this.swapToken,
                  tokenAmountPurchase: this.baseToken,
                  purchaseType: this.isStake ? 'buy_and_stake' : 'buy',
                  tokenPurchaseMethod: 'card',
                  transactionId: '',
                  walletAddress: this.walletAddress,
                  walletType: this.walletType,
                });
              },
            },
          });
          this.wertWidget.open();
        },
        error: (err: any) => {
          console.log('wert error response', err);
          this.mountError = true;
          // this.walletConnect.swapStatus = SwapStatus.not_started;
        },
      });
    }
  }
}
